import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { Lead } from './leads.model';
import { Data2Service } from '../common/data2.service';
import { DateService } from '../common/date.service';
import { UuidService } from '../common/uuid.service';

@Component({
	selector: 'app-leads',
	templateUrl: './leads.component.html',
	styleUrls: ['./leads.component.css'],
})
export class LeadsComponent implements OnInit {
	pageTitle: string;
	loader = false;
	private itemsBeforeDataLoad = 1;
	editable: boolean;
	lockEdit: boolean;

	lead: Lead = {
		id: null,
		author: null,
		owner: null,
		firstName: null,
		lastName: null,
		type: null,
		source: null,
		city: null,
		country: null,
		email1: null,
		email2: null,
		gender: null,
		pesel: null,
		phone1: null,
		phone2: null,
		street: null,
		tags: null,
		zip_code: null,
		status: 1,
		note: null,
		externalId: null,
		externalType: null,
	};
	errors = {
		type: '',
		source: '',
	};
	leadSources;

	gender = [
		{
			code: 'm',
			polish: 'Mężczyzna',
		},
		{
			code: 'f',
			polish: 'Kobieta',
		},
	];

	constructor(
		private readonly api: Data2Service,
		private readonly date: DateService,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
		private readonly uuid: UuidService,
	) {}

	ngOnInit(): void {
		if (this.route.snapshot.params['id']) {
			// We are in edit mode
			this.editable = true;
			this.lockEdit = true;
			this.lead.id = this.route.snapshot.params['id'];
			this.pageTitle = 'Edycja leada';
		} else {
			// We are in add mode
			this.editable = false;
			this.pageTitle = 'Dodawanie leada';
			this.lead.id = this.uuid.generate();
		}
		this.loader = true;
		this.api.get('/leadsSources/', (result, error) => {
			this.leadSources = result.data;
			this.loadData();
		});
	}
	private loadData(): void {
		if (!this.editable) {
			this.loader = false;
			return;
		}
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/leads/' + this.lead.id + '/', (result, error) => {
			this.loader = false;
			this.lead = result.data;
		});
	}

	editToggle(): void {
		this.lockEdit = !this.lockEdit;
	}

	submit() {
		let hasErrors = false;
		// if ($('form *[required]:invalid').length !== 0) {
		// 	$('form').addClass("was-validated");
		// 	$('.nav-link').removeClass('active');
		// 	$('.tab-pane').removeClass('active');
		// 	(<any>$('.tab-pane:has(*[required]:invalid)')).first().tab('show');
		// 	$('.nav-tabs .nav-link').each(function() {
		// 		if ($('#'+ $(this).attr('aria-controls')).hasClass("active")) {
		// 			$(this).addClass("active");
		// 			hasErrors = true;
		// 		}
		// 	});
		// }
		for (const key in this.errors) {
			if (!this.lead[key]) {
				this.errors[key] = true;
				hasErrors = true;
				continue;
			}
			this.errors[key] = false;
		}
		if (!this.checkPhone('phone1')) {
			hasErrors = true;
		}
		if (!this.checkPhone('phone2')) {
			hasErrors = true;
		}
		if (hasErrors) {
			return;
		}
		this.lockEdit = true;
		// wysyłanie danych
		if (this.editable) {
			this.api.put('/leads/' + this.lead.id + '/', this.lead, (result, error) => {
				if (error) {
					alert('error - check console');
					return;
				}
				this.router.navigate(['leads', this.lead.id]);
			});
		} else {
			this.api.post('/leads/', this.lead, (result, error) => {
				if (error) {
					alert('error - check console');
					return;
				}
				this.router.navigate(['leads', this.lead.id]);
			});
		}
	}

	private checkPhone(position: string): boolean {
		if (!this.lead[position]) {
			return true;
		}
		if (this.lead[position].match(/^\+([0-9]{11,})$/)) {
			document.getElementById(position).classList.remove('error');
			return true;
		}
		document.getElementById(position).classList.add('error');
		return false;
	}
}
